import React from 'react';
import { Box } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import { Outlet } from 'react-router';

const PublicLayout = () => {
    return (
        <>
            <Box
                height={'100%'}
                overflow={'auto'}
                sx={{
                    display: 'grid',
                    placeItems: 'center',
                }}
                pb={pxToRem(20)}
            >
                <Outlet />
            </Box>
        </>
    );
};

export default PublicLayout;
